import { db } from '@/firebaseInit'
// const debug = require('debug')('OD::Lib:Data:Tests')

export default {
  bindAll(vm) {
    vm.loadingTests = true
    vm
      .$bind('tests', db.collection('tests'))
      .then(tests => {
        vm.loadingTests = false
      })
      .catch(error => {
        vm.loadingTests = false
        vm.dbErrors.tests = error
      })
  },
  bindItem(vm, testId) {
    vm.loadingTest = true
    vm
      .$bind('test', db.collection('tests').doc(testId))
      .then(test => {
        vm.loadingTest = false
      })
      .catch(error => {
        vm.loadingTest = false
        vm.dbErrors.test = error
      })
  },
  add(vm, item) {
    vm.$firestoreRefs.tests.add(item)
  },
  update(vm, testId, item) {
    vm.$firestoreRefs.tests.doc(testId).update(item)
  },
  delete(vm, testId, item) {
    vm.$firestoreRefs.tests.doc(testId).delete()
  },
}
